import { FETCH_SIG_FINALTYPE_FINALDIST} from "../../actionTypes";
import { fetchSigFinalTypeandFinalDist } from "../../../../api/dashboard/sigtran/sigtran";

const request = () => ({ type: FETCH_SIG_FINALTYPE_FINALDIST.REQUEST });
const failure = (error) => ({ type: FETCH_SIG_FINALTYPE_FINALDIST.FAILURE, error });
const success = (data) => ({ type: FETCH_SIG_FINALTYPE_FINALDIST.SUCCESS,data});


export const getSigFinalTypeandFinalDist = (cp_name) => {
  return (dispatch, getState) => {
    dispatch(request());
    return fetchSigFinalTypeandFinalDist(cp_name)
      .then((res) => {
        dispatch(success(res));
        return Promise.resolve(true);
      })
      .catch((error) => {
        dispatch(failure(error?.message));
        return Promise.resolve(false);
      });
  };
};
